import { Navigate } from 'react-router-dom';
import { usePermissions } from '../context/PermissionsContext';

function ProtectedRoute({ children, permission }) {
  const { permissions } = usePermissions();

  if (permission && !permissions[permission]) {
    return <Navigate to="/admin/dashboard" replace />;
  }

  return children;
}

export default ProtectedRoute;
